//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CategoriesFilter',
  props: {
    categories: {
      type: Array,
      required: true,
      default: () => []
    },
    activeCategory: {
      type: String,
      required: false,
      default: () => null
    }
  },
  data() {
    return {
      showPrevArr: false,
      showNextArr: false,
      scrollWidth: 0,
      scrollCount: 140
    }
  },
  methods: {
    scrollContainer(count) {
      this.scrollWidth += count;
      this.$refs.container.scrollLeft = this.scrollWidth;
      this.showPrevArr = !!(this.scrollWidth > 0);
      this.showNextArr = !!(this.$refs.container.scrollWidth > this.scrollWidth + this.$refs.container.offsetWidth);
    }
  },
  mounted() {
    this.showNextArr = this.$refs.container.scrollWidth > this.$refs.container.scrollLeft + this.$refs.container.offsetWidth
  }
}
